module.exports = __webpack_public_path__ + "static/media/Terms.6ffd63e6.md";